import React from "react";
import classes from "./styles/style.module.css";
import ListElement from "./ListElement";
import { useSelector } from "react-redux";

const MenuItemElement = ({ title, menuItems }) => {
  const { currentUser } = useSelector(({ user }) => user);
  let items = menuItems.map((item, index) => {
    if (!currentUser && item.action === "logOut") {
      return null;
    }
    return (
      <ListElement
        icon={item.itemIcon}
        label={item.itemName}
        key={index}
        link={item.link}
        linkNewTab={item.linkNewTab ? item.linkNewTab : false}
        action={item.action ? item.action : ""}
      />
    );
  });
  return (
    <div className="w-100">
      {title && <p className={classes.itemTitle}>{title}</p>}
      <div className={classes.itemsContainer}>
        <div className="row m-0 p-0">{items}</div>
      </div>
    </div>
  );
};

export default MenuItemElement;
